const dateOnly = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString().split("T")[0];
};

// Same inclusive date boundaries as the expense mileage calculation.
export function findFormationMileageRate(rates, startDate) {
  const day = dateOnly(startDate);
  if (!day || !Array.isArray(rates)) return null;

  const rate = rates.find((item) => {
    const from = dateOnly(item?.Datedebut);
    const to = dateOnly(item?.DatedeFin);
    return from && (!item.DatedeFin || to) && day >= from && (!to || day <= to);
  });
  if (rate?.value == null || String(rate.value).trim() === "") return null;
  const amount = Number(String(rate.value).replace(",", "."));
  return Number.isFinite(amount) && amount >= 0 ? amount : null;
}

export function calculateFormationTransport(kilometres, rate) {
  if (rate == null || !Number.isFinite(rate) || rate < 0) return "";
  const value = String(kilometres ?? "").trim().replace(",", ".");
  if (!/^\d+(\.\d*)?$|^\.\d+$/.test(value)) return "";
  const amount = Number(value) * rate;
  return Number.isFinite(amount) ? amount.toFixed(2) : "";
}
